<template>
  <div style="width: 100%; height: 100%;">
    <div class="warningOrder">
      <div class="header">
        <div>
          <span>{{ $t('warning.warningOrder') }}</span>
        </div>
        <div class="buttons_group">
          <a-button type="primary" @click="showReasonModal">{{ $t("warningOrder.reasonSetting") }}</a-button>
          <a-button type="primary" style="margin-left: 10px" @click="showHandleMethodModal">{{ $t("warningOrder.methodSetting") }}</a-button>
          <a-button style="margin-left: 10px" type="primary" @click="renderTableData(1)">{{ $t("buttons.search") }}</a-button>
        </div>
      </div>
      <el-table v-loading="isTableLoading" :data="list">
        <el-table-column prop="code" width="150">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("warningOrder.code") }}
              <span class="icons unset" style="cursor: pointer;" @click="sort($event, 'code')">
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
            <a-input v-model="queryParams.code" allow-clear @keyup.enter="renderTableData(1)" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highlightInfo.code">{{ scope.row.code }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="level" width="90">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("warning.orderLevel") }}
            </div>
            <a-select style="width: 100%;" v-model="filterParams.level" @change="renderTableData(1)">
              <a-select-option value="">{{ $t("common.all") }}</a-select-option>
              <a-select-option v-for="(v, k) in levels" :key="k">
                {{ v[lang] }}
              </a-select-option>
            </a-select>
          </template>
          <template slot-scope="scope">
            <span :class="scope.row.level">{{ levels[scope.row.level] ? levels[scope.row.level][lang] : "" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" width="100">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("warningOrder.status") }}
            </div>
            <a-select style="width: 100%;" v-model="filterParams.status" @change="renderTableData(1)">
              <a-select-option value="">{{ $t("common.all") }}</a-select-option>
              <a-select-option v-for="(v, k) in orderStatuses" :key="k">
                {{ v[lang] }}
              </a-select-option>
            </a-select>
          </template>
          <template slot-scope="scope">
            <span :class="orderStatuses[scope.row.status] ? orderStatuses[scope.row.status][lang] : ''">{{ orderStatuses[scope.row.status] ? orderStatuses[scope.row.status][lang] : "" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="warningType" width="150">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("device.warningType") }}
            </div>
            <a-select style="width: 100%;" v-model="filterParams.warningType" @change="renderTableData(1)">
              <a-select-option value="">{{ $t("common.all") }}</a-select-option>
              <a-select-option v-for="(v, k) in warningTypesMap" :key="k">
                {{ v[lang] }}
              </a-select-option>
            </a-select>
          </template>
          <template slot-scope="scope">
            {{ warningTypesMap[scope.row.warningType] ? warningTypesMap[scope.row.warningType][lang] : ""  }}
          </template>
        </el-table-column>
        <el-table-column prop="deviceCode" width="150">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("warning.deviceCode") }}
              <span class="icons unset" style="cursor: pointer;" @click="sort($event, 'deviceCode')">
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
            <a-input style="width: 100%;" v-model="queryParams.deviceCode" @keyup.enter="renderTableData(1)" />
          </template>
          <template slot-scope="scope">
            <template v-if="ableToDelete">
              <a-button :loading="scope.row.isGoingToDevice" @click="goToDevice(scope.row)" style="padding-left: 0; user-select: auto" type="link">
                <text-highlight :queries="highlightInfo.deviceCode">{{ scope.row.deviceCode }}</text-highlight>
              </a-button>
            </template>
            <text-highlight v-else :queries="highlightInfo.deviceCode">{{ scope.row.deviceCode }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="device.name" width="120">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("common.deviceName") }}
              <span class="icons unset" style="cursor: pointer;" @click="sort($event, 'device.name')">
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
            <a-input style="width: 100%;" v-model="queryParams['device.name']" @keyup.enter="renderTableData(1)" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highlightInfo['device.name']">{{ scope.row.device ? scope.row.device.name : "" }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="device.model" width="120">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("common.model") }}
              <span class="icons unset" style="cursor: pointer;" @click="sort($event, 'device.model')">
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
            <a-input style="width: 100%;" v-model="queryParams['device.model']" @keyup.enter="renderTableData(1)" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highlightInfo['device.model']">{{ scope.row.device ? scope.row.device.model : "" }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="customer.company" width="210">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("common.customerName") }}
              <span class="icons unset" style="cursor: pointer;" @click="sort($event, 'customer.company')">
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
            <a-input style="width: 100%;" v-model="queryParams['customer.company']" @keyup.enter="renderTableData(1)" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highlightInfo['customer.company']">{{ scope.row.customer ? scope.row.customer.company : "" }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="organizations" width="210">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("device.organization") }}
              <span class="icons unset" style="cursor: pointer;" @click="sort($event, 'customer.company')">
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
            <a-input style="width: 100%;" v-model="queryParams['customer.salesmen.organizationName']" @keyup.enter="renderTableData(1)" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highlightInfo['customer.salesmen.organizationName']">{{ scope.row.organizations }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="handlerName" width="120">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("warning.handler") }}
              <span class="icons unset" style="cursor: pointer;" @click="sort($event, 'handlerName')">
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
            <a-input style="width: 100%;" v-model="queryParams.handlerName" @keyup.enter="renderTableData(1)" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highlightInfo.handlerName">{{ scope.row.handlerName }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="handler" width="120">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("warningOrder.handlerPhoneNumber") }}
              <!-- <span class="icons unset" style="cursor: pointer;" @click="sort($event, 'handlerPhoneNumber')">
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span> -->
            </div>
            <a-input style="width: 100%;" v-model="queryParams.handler" @keyup.enter="renderTableData(1)" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highlightInfo.handler">{{ scope.row.handler }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="followerName" width="120">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("common.followers") }}
              <span class="icons unset" style="cursor: pointer;" @click="sort($event, 'followerName')">
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
            <a-input style="width: 100%;" v-model="queryParams.followerName" @keyup.enter="renderTableData(1)" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highlightInfo.followerName">{{ scope.row.followerName }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="follower" width="120">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("warningOrder.followerPhoneNumber") }}
              <!-- <span class="icons unset" style="cursor: pointer;" @click="sort($event, 'handlerPhoneNumber')">
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span> -->
            </div>
            <a-input style="width: 100%;" v-model="queryParams.follower" @keyup.enter="renderTableData(1)" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highlightInfo.follower">{{ scope.row.follower }}</text-highlight>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="reason" width="130">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("device.reasons") }}
            </div>
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highlightInfo.reason">{{ scope.row.reason }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="handleMethod" width="150">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("warningOrder.handleMethod") }}
            </div>
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highlightInfo.handleMethod">{{ scope.row.handleMethod }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="solution" width="150">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("warningOrder.solution") }}
            </div>
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highlightInfo.solution">{{ scope.row.solution }}</text-highlight>
          </template>
        </el-table-column> -->
        <el-table-column prop="estimatedTime" width="150">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("warningOrder.estimatedTime") }}
              <span class="icons unset" style="cursor: pointer;" @click="sort($event, 'code')">
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.estimatedTime }}
          </template>
        </el-table-column>
        <el-table-column prop="createdUser" width="150">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("common.createdBy") }}
              <span class="icons unset" style="cursor: pointer;" @click="sort($event, 'createUser')">
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
            <a-input v-model="queryParams.createUser" @keyup.enter="renderTableData(1)" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highlightInfo.createUser">{{ scope.row.createUser }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" width="150">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("common.createdAt") }}
              <span class="icons unset" style="cursor: pointer;" @click="sort($event, 'createdAt')">
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.createdAt }}
          </template>
        </el-table-column>
        <el-table-column prop="updatedUser" width="150">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("common.updatedBy") }}
              <span class="icons unset" style="cursor: pointer;" @click="sort($event, 'updateUser')">
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
            <a-input v-model="queryParams.updateUser" @keyup.enter="renderTableData(1)" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highlightInfo.updateUser">{{ scope.row.updateUser }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="updatedAt" width="150">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("common.updatedAt") }}
              <span class="icons DESC" style="cursor: pointer;" @click="sort($event, 'updatedAt')">
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.updatedAt }}
          </template>
        </el-table-column>
        <el-table-column prop="processedTime" width="150">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("warningOrder.processedTime") }}
              <!-- <span class="icons unset" style="cursor: pointer;" @click="sort($event, 'processedTime')">
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span> -->
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.processedTime }}
          </template>
        </el-table-column>
        <el-table-column prop="handledTime" width="150">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("warningOrder.handledTime") }}
              <span class="icons unset" style="cursor: pointer;" @click="sort($event, 'handledTime')">
                <a-icon type="caret-up"></a-icon>
                <a-icon type="caret-down"></a-icon>
              </span>
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.handledTime }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" width="300">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
              {{ $t("common.operation") }}
            </div>
          </template>
          <template slot-scope="scope">
            <a-button type="link" style="padding-left: 0;" @click="showWarningRemindModal(scope.row)">{{ $t("warning.otherWarnings") }}</a-button>
            <a-button type="link" style="padding-left: 0;" @click="showWarningOrderModal(scope.row)">{{ $t('warningOrder.orderInfo') }}</a-button>
            <a-button :loading="scope.row.isGoingToHistory" type="link" style="padding-left: 0;" v-if="ableToHistory" @click="goToHistory(scope.row)">{{ $t('device.history') }}</a-button>
            <!-- <a-button v-if="scope.row.status === 'PENDING'" type="link" style="padding-left: 0;" @click="showHandleModal(scope.row.code)">{{ $t('warningOrder.handle') }}</a-button> -->
            <!-- <a-button :loading="scope.row.loading" v-if="scope.row.status === 'PROCESSING'" type="link" style="padding-left: 0;" @click="showHandledModal(scope.row)">{{ $t('warningOrder.finish') }}</a-button> -->
            <!-- <a-button :loading="scope.row.detailLoading" v-if="['PROCESSED', 'CHECKING'].includes(scope.row.status)" type="link" style="padding-left: 0;" @click="showDetail(scope.row)">{{ $t('warningOrder.handledDetails') }}</a-button> -->
            <!-- <a-button :loading="scope.row.commentsLoading" @click="showCommentsModal(scope.row)" type="link" style="padding-left: 0;">{{ $t('warningOrder.comment') }}</a-button> -->
            <a-popconfirm
              :title="$t('warningOrder.ctdo')"
              :okText="$t('common.okText')"
              :cancelText="$t('common.cancelText')"
              @confirm="removeOrder(scope.row)"
            >
              <a-button :loading="scope.row.isDeletingOrder" type="link" style="padding-left: 0">{{ $t("buttons.delete") }}</a-button>
            </a-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <a-pagination
        style="float: right; margin-top: 20px; padding-bottom: 20px"
        :current="pagination.current"
        :total="pagination.total"
        @change="handlePageChange"
      />
    </div>
    <WarningOrderModal :warningTypes="typesForWarningOrder" :info="orderInfo" :visible="oVisible" :closeModal="closeWarningOrderModal" :loading="isWarningOrderLoading" :changeLoading="changeWarningOrderModalLoading" :refresh="renderTableData" />
    <a-modal v-model="estimatedTimeModalVisible" :title="$t('warningOrder.estimatedTime')" :afterClose="clearEstimatedTime" :confirmLoading="isHandling" @ok="submitEstimatedTime">
      <a-form-model :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item :label="$t('warningOrder.estimatedTime')">
          <a-date-picker v-model="estimatedTime" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal v-model="handledModalVisible" :title="$t('warningOrder.finish')" :width="700" :afterClose="clearHandledInfo" @ok="submitHandledInfo" :confirmLoading="isFinishing" :okButtonProps="{ style: { display: isDetailModalShow ? 'none' : 'inline-block' } }">
      <a-form-model :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" :model="handledForm" ref="handledFormRef" :rules="handledRules">
        <a-form-model-item :label="$t('warningOrder.handleMethod')" prop="handleMethod">
          <a-select v-model="handledForm.handleMethod" mode="tags">
            <a-select-option v-for="h in handleMethods" :key="h.code" :value="h.handleMethod">
              {{ h.handleMethod }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('warningOrder.solution')">
          <a-input v-model="handledForm.solution" />
        </a-form-model-item>
        <a-form-model-item :label="$t('warningOrder.resolvable')">
          <a-switch v-model="handledForm.unabelSolve" :checked-children="$t('common.yes')" :un-checked-children="$t('common.no')" />
        </a-form-model-item>
        <a-form-model-item :label="$t('warningOrder.live')">
          <div class="upload">
            <button
              aria-disabled="false"
              type="button"
              class="el-button el-button"
              :key="fileList.length"
            >
              <span style="padding: 8px 15px;" class="" @click="showFileModal"
                ><i class="el-icon-upload"></i>&nbsp;&nbsp;{{ $t('buttons.uploadPic') }}</span
              >
            </button>
            <input
              ref="InputFileDOm"
              class="file"
              type="file"
              :accept="'.mp4,.jpg,.jpeg,.png,.webm'"
              :limit="6"
              @change="hadnleFileCHnage($event, '0')"
              multiple
            />
            <div class="upload-demo" data-v-1ab1ffd8="">
              <ul
                class="el-upload-list el-upload-list--text"
                :key="fileList.length"
              >
                <li
                  tabindex="0"
                  v-for="(file, index) in fileList"
                  :key="srcList[index].path"
                  style="float: left;width: 100px; height: 100px; position: relative"
                  @mouseover="srcList[index].isMaskShow = true; $forceUpdate()"
                  @mouseleave="srcList[index].isMaskShow = false; $forceUpdate()"
                >
                  <div v-show="srcList[index].isMaskShow" class="mask" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, .3); z-index: 100; display: flex; justify-content: center; align-items: center; cursor: pointer;">
                    <a-icon type="eye" style="color: #ccc; font-size: 20px;" :style="{ marginRight: isDetailModalShow ? '0' : '10px' }" @click="previewImg(index)" />
                    <a-icon v-show="!isDetailModalShow" type="delete" style="color: #ccc; font-size: 20px" @click="rF(index)" />
                  </div>
                  <img :src="srcList[index].path" style="width: 100%; height: 100%; object-fit: cover; cursor: pointer" />
                </li>
              </ul>
            </div>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal v-model="commentModalShow" :title="$t('warningOrder.comment')" :width="700" :okButtonProps="{ style: { display: 'none' } }">
      <h4 class="flex">{{ selectedOrderCode }} - {{ selectedOrderType }}<a-button v-show="!isCommentingInput" type="link" @click="showCommentInput">{{ $t("warningOrder.comment") }}</a-button></h4>
      <a-empty v-if="comments.length === 0 && !isCommentingInput">
        <span slot="description">{{ $t('warningOrder.noComments') }}</span>
      </a-empty>
      <div v-else style="max-height: 560px; overflow: auto" v-loading="isCommentLoading">
        <div class="input_wrapper" v-show="isCommentingInput">
          <a-input style="width: 90%; margin-right: 10px" v-model="comment" />
          <div class="comment_icons" style="display: inline-block;" v-show="!isSubmittingComment">
            <a-icon @click="submitComment()" style="margin-right: 10px; cursor: pointer" type="check" />
            <a-icon @click="clearComment" style="cursor: pointer;" type="close" />
          </div>
          <a-icon type="loading" v-show="isSubmittingComment" />
        </div>
        <ul>
          <li v-for="c in comments" :key="c.id" style="padding: 15px 0;">
            <span class="username">{{ c.realName }}: </span>
            <br />
            <div class="content">{{ c.content }}</div>
            <span class="time">{{ c.createdAt }}</span>
            <a-button type="link" @click="replyComment(c)">{{ $t("warningOrder.reply" )}}</a-button><a-button type="link" style="color: red; padding-left: 0" @click="removeComment(c.id)" v-if="ableToDelete">{{ $t('buttons.delete') }}</a-button>
            <div class="input_wrapper" v-show="c.isRepling">
              <a-input style="width: 90%; margin-right: 10px" v-model="comment" />
              <div class="comment_icons" style="display: inline-block;" v-show="!isSubmittingComment">
                <a-icon @click="submitComment(c.id)" style="margin-right: 10px; cursor: pointer" type="check" />
                <a-icon @click="clearComment" style="cursor: pointer;" type="close" />
              </div>
              <a-icon type="loading" v-show="isSubmittingComment" />
            </div>
            <ul style="padding-left: 30px" v-show="c.children && c.children.length">
              <li v-for="cc in c.children" :key="cc.id" style="padding: 15px 0;">
                <span class="username">{{ cc.realName }}: </span>
                <br />
                <div class="content">{{ cc.content }}</div>
                <span class="time">{{ cc.createdAt }}</span>
                <a-button type="link" @click="replyComment(cc)">{{ $t("warningOrder.reply" )}}</a-button><a-button type="link" style="color: red; padding-left: 0" @click="removeComment(cc.id)" v-if="ableToDelete">{{ $t('buttons.delete') }}</a-button>
                <div class="input_wrapper" v-show="cc.isRepling">
                  <a-input style="width: 90%; margin-right: 10px" v-model="comment" />
                  <div class="comment_icons" style="display: inline-block;" v-show="!isSubmittingComment">
                    <a-icon @click="submitComment(c.id)" style="margin-right: 10px; cursor: pointer" type="check" />
                    <a-icon @click="clearComment" style="cursor: pointer;" type="close" />
                  </div>
                  <a-icon type="loading" v-show="isSubmittingComment" />
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </a-modal>
    <ReasonModal :visible="isReasonModalVisible" :warningCodeNameMap="warningCodeNameMap" :closeModal="closeReasonModal" :handleConfirm="closeReasonModal" />
    <HandleMethodModal :visible="isHandleMethodModalVisible" :warningCodeNameMap="warningCodeNameMap" :closeModal="closeHandleMethodModal" :handleConfirm="closeHandleMethodModal" />
    <a-modal v-model="isWarningRemindVisible" :width="1300">
      <WarningRemind :device="selectedDevice" :showDetailMethod="null" />
    </a-modal>
  </div>
</template>

<script>
import TextHighlight from "vue-text-highlight"
import WarningOrderModal from "@/components/common/WarningOrderModal.vue"
import moment from "moment"
import ReasonModal from "@/components/common/ReasonModal.vue"
import HandleMethodModal from "@/components/common/HandleMethodModal.vue"
import WarningRemind from '@/views/EquipmentManager/EquipmentList/View/WarningRemind.vue'

import {
  queryOrders,
  handleOrder,
  getHandleMethodList,
  finishOrder,
  getOrderByCode,
  getOrderCommentsList,
  createComment,
  deleteComment,
  deleteOrder
} from "@/api/warningOrder"
import { levels, orderStatuses } from "./orderSelectionOptions"
import { getMenusOfCurrentUser } from "@/api/auth/menu"
import { searchDeviceList } from "@/api/device"

export default {
  components: {
    TextHighlight,
    WarningOrderModal,
    ReasonModal,
    HandleMethodModal,
    WarningRemind
  },
  data() {
    return {
      queryParams: {
        code: "",
        deviceCode: "",
        "device.name": "",
        "device.model": "",
        "customer.company": "",
        "customer.salesmen.organizationName": "",
        handlerName: "",
        handler: "",
        reason: "",
        handleMethod: "",
        solution: "",
        followerName: "",
        follower: "",
        createUser: "",
        updateUser: ""
      },
      filterParams: {
        level: "",
        status: "",
        warningType: ""
      },
      sortParams: {
        updatedAt: "DESC"
      },
      highlightInfo: {
        code: "",
        deviceCode: "",
        "device.name": "",
        "device.model": "",
        "customer.company": "",
        "customer.salesmen.organizationName": "",
        handlerName: "",
        handler: "",
        reason: "",
        handleMethod: "",
        solution: "",
        followerName: "",
        follower: "",
        createUser: "",
        updateUser: ""
      },
      isTableLoading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      list: [],
      levels,
      orderStatuses,
      warningTypesMap: {},
      typesForWarningOrder: [],
      orderInfo: {},
      oVisible: false,
      isWarningOrderLoading: false,
      estimatedTimeModalVisible: false,
      estimatedTime: null,
      isHandling: false,
      handledModalVisible: false,
      handledForm: {
        solution: "",
        handleMethod: [],
        unableSolve: false
      },
      fileList: [],
      srcList: [],
      handleMethods: [],
      isFinishing: false,
      isDetailModalShow: false,
      comments: [],
      commentModalShow: false,
      isCommentingInput: false,
      selectedOrderCode: "",
      selectedOrderType: "",
      isSubmittingComment: false,
      comment: "",
      isCommentLoading: false,
      ableToDelete: false,
      ableToDevice: false,
      ableToHistory: false,
      handledRules: {},
      isReasonModalVisible: false,
      warningCodeNameMap: {},
      isHandleMethodModalVisible: false,
      selectedDevice: {},
      isWarningRemindVisible: false
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  created() {
    this.delField = []
    this.ableToDelete = this.getAuthorities("/warning/order").find(a => a.code === "warning:workOrder:comment:delete")
    this.ableToDevice = !!this.getAuthorities("/equipment/list").find(a => ["device:manage:device:update", "agent:device:manage:device:update"].includes(a.code))
    this.ableToHistory = !!this.getAuthorities("/equipment/list").find(a => ["device:manage:device:history:query"].includes(a.code))
  },
  mounted() {
    this.getWarningTypes()
    this.renderTableData()
  },
  methods: {
    translate() {
      this.handledRules = {
        handleMethod: [
          {
            required: true,
            message: this.$t("warningOrder.selectHandleMethod")
          }
        ]
      }
    },
    setQueryParams() {
      const query = {
        query: [],
        filter: [],
        sort: []
      }
      for (let key in this.queryParams) {
        query.query.push({
          field: key,
          value: this.queryParams[key].trim()
        })
      }
      for (let key in this.filterParams) {
        if (this.filterParams[key]) {
          query.filter.push({
            field: key,
            value: this.filterParams[key]
          })
        }
      }
      if (query.filter.length) {
        query.filter.push({
          field: "mode",
          value: "AND"
        })
      }
      for (let key in this.sortParams) {
        if (this.sortParams[key] !== "unset") {
          query.sort.push({
            field: key,
            value: this.sortParams[key]
          })
        }
      }
      return query
    },
    async renderTableData(p = this.pagination.current) {
      this.isTableLoading = true
      this.pagination.current = p
      try {
        const query = this.setQueryParams()
        const { data } = await queryOrders(this.pagination.current, this.pagination.pageSize, query)
        this.pagination.total = data.total
        this.list = data.records.map(r => {
          r.organizations = {};
          (r.customer?.salesmen || []).forEach(u => {
            if (u.organizationName) {
              r.organizations[u.organizationName] = u.organizationName
            }
          })
          r.organizations = Object.keys(r.organizations).join("，")
          r.createdAt = moment(r.createdAt).format("YYYY-MM-DD HH:mm:ss")
          r.updatedAt = moment(r.updatedAt).format("YYYY-MM-DD HH:mm:ss")
          if (r.estimatedTime) {
            r.estimatedTime = moment(r.estimatedTime).format("YYYY-MM-DD")
          }
          if (r.processedTime) {
            r.processedTime = moment(r.processedTime).format("YYYY-MM-DD HH:mm:ss")
          }
          if (r.handledTime) {
            r.handledTime = moment(r.handledTime).format("YYYY-MM-DD HH:mm:ss")
          }
          return r
        })
        let q
        for (let key in this.queryParams) {
          q = this.queryParams[key].trim()
          this.highlightInfo[key] = q
        }
      } catch(e) {
        console.log(e)
      } finally {
        this.isTableLoading = false
      }
    },
    async getWarningTypes() {
      try {
        const { data } = await getMenusOfCurrentUser()
        const warnings = data.find(d => d.code === "WARNING")
        const i = warnings.children.findIndex(c => c.routeName === "WarningOrder")
        if (i > -1) {
          warnings.children.splice(i, 1)
        }
        let w, d
        const wt = {}
        for (let i = 0; i < warnings.children.length; i++) {
          w = warnings.children[i]
          wt[w.routeName] = {}
          if (w.details) {
            for (let j = 0; j < w.details.length; j++) {
              d = w.details[j]
              if (d.locale === "zh-CN") {
                wt[w.routeName].zh = d.name
                w["zh-CN"] = d.name
              }
              if (d.locale === "en-US") {
                wt[w.routeName].en = d.name
                w["en-US"] = d.name
              }
            }
          }
        }
        this.typesForWarningOrder = warnings.children
        this.warningTypesMap = wt
        let t
        const map = {}
        for (let i = 0; i < warnings.children.length; i++) {
          t = warnings.children[i]
          map[t.routeName] = {
            zh: t["zh-CN"],
            en: t["en-US"]
          }
        }
        this.warningCodeNameMap = map
      } catch(e) {
        console.log(e)
      }
    },
    handlePageChange(p) {
      this.renderTableData(p)
    },
    sort(e, field) {
      let node = e.target
      while (node.nodeName !== "SPAN") {
        node = node.parentNode
      }
      let c = node.classList[1]
      node.classList.remove(c)
      switch(c) {
        case "unset":
          node.classList.add("ASC")
          this.sortParams[field] = "ASC"
          break
        case "ASC":
          node.classList.add("DESC")
          this.sortParams[field] = "DESC"
          break
        case "DESC":
          node.classList.add("unset")
          delete this.sortParams[field]
          break
        default:
          break
      }
      this.renderTableData()
    },
    closeWarningOrderModal() {
      this.oVisible = false
    },
    changeWarningOrderModalLoading(v) {
      this.isWarningOrderLoading = v
    },
    showWarningOrderModal(r) {
      this.oVisible = true
      this.orderInfo = {
        deviceCode: r.deviceCode,
        warningType: r.warningType,
        isEdit: true,
        code: r.code
      }
    },
    showHandleModal(c) {
      this.selectedOrderCode = c
      this.estimatedTimeModalVisible = true
    },
    clearEstimatedTime() {
      this.estimatedTime = null
      this.selectedOrderCode = null
    },
    async submitEstimatedTime() {
      if (!this.estimatedTime) {
        return this.$message.warning(this.$t("warningOrder.enterEstimatedTime"))
      }
      this.isHandling = true
      try {
        const { message } = await handleOrder(this.selectedOrderCode, +this.estimatedTime._d)
        this.$message.success(message)
        this.estimatedTimeModalVisible = false
        this.renderTableData()
      } catch(e) {
        console.log(e)
      } finally {
        this.isHandling = false
      }
    },
    async showHandledModal(r) {
      r.loading = true
      this.list = [...this.list]
      this.selectedOrderCode = r.code
      try {
        const { data } = await getHandleMethodList(r.warningType)
        this.handleMethods = data
      } catch(e) {
        console.log(e)
      } finally {
        r.loading = false
        this.list = [...this.list]
        this.handledModalVisible = true
      }
    },
    showFileModal() {
      this.$refs.InputFileDOm.click()
    },
    hadnleFileCHnage(e) {
      let i
      for (i = 0; i < e.target.files.length; i++) {
        if (!this.onBeforeUpload(e.target.files[i])) {
          break;
        }
      }
      if (i == e.target.files.length) {
        this.fileList = this.fileList.concat(Array.from(e.target.files))
        this.srcList = this.fileList.map(f => {
          if (f.id) {
            return f
          } else {
            return {
              path: '',
              isMaskShow: false
            }
          }
        })
        this.fileList.forEach((f, i) => {
          if (!f.id) {
            const fr = new FileReader()
            fr.readAsDataURL(f)
            fr.onload = e => {
              this.srcList[i] = {
                path: "data:image/png;base64," + e.target.result.substring(e.target.result.indexOf(',') + 1),
                isMaskShow: false
              }
              this.$forceUpdate()
            }
          }
        })
      }
    },
    previewImg(i) {
      const imgList = this.srcList.map(s => s.path)
      this.$hevueImgPreview({
        multiple: true,
        nowImgIndex: i,
        imgList
      })
    },
    rF(i) {
      this.$Mconfirm(this.$t('messages.ctrp'), this.$t('messages.hint'), {
        confirmButtonText: this.$t('common.okText'),
        cancelButtonText: this.$t('common.cancelText'),
        type: "warning"
      })
      .then(() => {
        console.log(this.fileList[i]);
        if (this.fileList[i].id) {
          this.delField.push(this.fileList[i].id)
        }
        const arr = [...this.fileList];
        arr.splice(i, 1);
        this.srcList.splice(i, 1)
        this.fileList = arr;
        this.$forceUpdate();
        this.$EM({
          type: "success",
          message: this.$t('messages.rs')
        });
        return true;
      })
      .catch((e) => {
        console.log(e)
        this.$EM({
          type: "info",
          message: this.$t('messages.cr')
        });
      })
    },
    onBeforeUpload(file) {
      let acceptTypes;

      acceptTypes = [
        "image/jpg",
        "image/jpeg",
        "image/png"
      ];

      if (file.size > 1024 * 1024 * 500) {
        // 文件大于 30M 时取消上传
        ElNotification({
          type: "error",
          message: this.$t('messages.lessThan500MB')
        });
        return false;
      }
      if (!acceptTypes.includes(file.type)) {
        // 继续上传
        ElNotification({
          type: "error",
          message: this.$t('messages.rightFile')
        });
        return false; // 停止上传
      }
      return true;
    },
    clearHandledInfo() {
      this.handledForm = {
        solution: "",
        handleMethod: [],
        unableSolve: false
      }
      this.$refs.handledFormRef.clearValidate()
      this.fileList = []
      this.srcList = []
      this.isDetailModalShow = false
    },
    submitHandledInfo() {
      this.$refs.handledFormRef.validate(async valid => {
        if (valid) {
          this.isFinishing = true
          try {
            const form = { ...this.handledForm }
            form.handleMethod = form.handleMethod.join(";")
            form.code = this.selectedOrderCode
            const { message } = await finishOrder(form, this.fileList)
            this.$message.success(message)
            this.handledModalVisible = false
            this.renderTableData()
          } catch(e) {
            console.log(e)
          } finally {
            this.isFinishing = false
          }
        }
      })
    },
    async showDetail(r) {
      r.detailLoading = true
      this.list = [...this.list]
      this.isDetailModalShow = true
      try {
        const { data } = await getOrderByCode(r.code)
        this.selectedOrderCode = r.code
        this.handledForm.solution = data.solution
        this.handledForm.handleMethod = data.handleMethod.split(";")
        this.handledForm.unabelSolve = data.unabelSolve
        this.fileList = []
        this.srcList = []
        const promises = []
        data.attachments.forEach(a => {
          this.fileList.push(a)
          this.srcList.push({
            isMaskShow: false,
            path: a.uri
          })
        })
        await Promise.all(promises)
        const res = await getHandleMethodList(r.warningType)
        this.handleMethods = res.data
        this.handledModalVisible = true
      } catch(e) {
        console.log(e)
      } finally {
        r.detailLoading = false
        this.list = [...this.list]
      }
    },
    async showCommentsModal(r) {
      r.commentsLoading = true
      this.list = [...this.list]
      try {
        this.selectedOrderCode = r.code
        this.selectedOrderType = this.warningTypesMap[r.warningType][this.lang]
        await this.renderCommentsList(r.code)
        this.commentModalShow = true
      } catch(e) {
        console.log(e)
      } finally {
        r.commentsLoading = false
        this.list = [...this.list]
      }
    },
    showCommentInput() {
      this.setRepling()
      this.isCommentingInput = true
    },
    async renderCommentsList(c) {
      this.isCommentLoading = true
      try {
        const { data } = await getOrderCommentsList(c)
        this.comments = data
        this.setTime()
      } catch(e) {
        console.log(e)
      } finally {
        this.isCommentLoading = false
      }
    },
    async submitComment(pid) {
      if (!this.comment) {
        return this.$message.warning(this.$t("warningOrder.enterComment"))
      }
      const o = {
        workOrderCode: this.selectedOrderCode,
        content: this.comment
      }
      if (pid) {
        o.pid = pid
      }
      this.isSubmittingComment = true
      try {
        const { message } = await createComment(o)
        this.$message.success(message)
        this.setRepling()
        this.comment = ""
        this.renderCommentsList(this.selectedOrderCode)
      } catch(e) {
        console.log(e)
      } finally {
        this.isSubmittingComment = false
      }
    },
    clearComment() {
      this.setRepling()
      this.comments = [...this.comments]
      this.comment = ""
    },
    replyComment(c) {
      this.setRepling()
      c.isRepling = true
      this.comments = [...this.comments]
    },
    setTime() {
      let c, cc
      for (let i = 0; i < this.comments.length; i++) {
        c = this.comments[i]
        if (c.createdAt) {
          c.createdAt = moment(c.createdAt).format("YYYY-MM-DD HH:mm:ss")
        }
        if (c.children) {
          for (let j = 0; j < c.children.length; j++) {
            cc = c.children[j]
            if (cc.createdAt) {
              cc.createdAt = moment(cc.createdAt).format("YYYY-MM-DD HH:mm:ss")
            }
          }
        }
      }
    },
    setRepling(flag = false) {
      this.isCommentingInput = flag
      let c, cc
      for (let i = 0; i < this.comments.length; i++) {
        c = this.comments[i]
        c.isRepling = flag
        if (c.children) {
          for (let j = 0; j < c.children.length; j++) {
            cc = c.children[j]
            cc.isRepling = flag
          }
        }
      }
    },
    removeComment(id) {
      const okButtonProps = {
        props: {
          loading: false
        }
      }
      this.$confirm({
        title: this.$t("warningOrder.confirmToDelete"),
        content: this.$t("warningOrder.confirm"),
        okButtonProps,
        onOk: async () => {
          try {
            const { message } = await deleteComment(id)
            this.$message.success(message)
            this.isCommentLoading = true
            this.renderCommentsList(this.selectedOrderCode)
          } catch(e) {
            console.log(e)
          }
        }
      })
    },
    async removeOrder(r) {
      r.isDeletingOrder = true
      this.list = [...this.list]
      try {
        const { message } = await deleteOrder(r.code)
        this.$message.success(message)
        let page = this.pagination.current
        if (page > 1 && this.list.length < 2) {
          page = this.pagination.current - 1
        }
        this.renderTableData(page)
      } catch(e) {
        console.log(e)
      } finally {
        r.isDeletingOrder = false
        this.list = [...this.list]
      }
    },
    showReasonModal() {
      this.isReasonModalVisible = true
    },
    closeReasonModal() {
      this.isReasonModalVisible = false
    },
    showHandleMethodModal() {
      this.isHandleMethodModalVisible = true
    },
    closeHandleMethodModal() {
      this.isHandleMethodModalVisible = false
    },
    showWarningRemindModal(r) {
      this.selectedDevice = r.device
      this.isWarningRemindVisible = true
    },
    async goToDevice(r) {
      r.isGoingToDevice = true
      this.list = [...this.list]

      const { success, data } = await this.requestDevice(r.device.id)
      if (success) {
        this.$store.commit("setDeviceInfo", data)
        r.isGoingToDevice = false
        this.list = [...this.list]
        this.$router.push({
          path: "/equipment/list/submit/edit",
          query: {
            key: "warningHistory"
          }
        })
      } else {
        return this.$message.warning(this.$t("warning.noDevice"))
      }
    },
    async requestDevice(id) {
      let success = false, d = {}

      try {
        const { data } = await searchDeviceList(1, 10, {
          query: [],
          filter: [
            {
              field: "id",
              value: id
            }
          ]
        })
        
        if (data.total) {
          success = true
          d= data.records[0]
          d.status = (d.status || "").split(",")
        } else {
          success = false
        }
      } catch(e) {
        success = false
      }

      return { success, data: d }
    },
    async goToHistory(r) {
      r.isGoingToHistory = true
      this.list = [...this.list]

      const { success, data } = await this.requestDevice(r.device.id)
      if (success) {
        this.$router.push({
          name: "history",
          params: {
            machineId: data.code,
            machineType: data.model,
            protocolCode: data.protocolCode,
            id: data.id,
            intervalTime: data.intervalTime,
            name: data.name
          }
        })
      } else {
        return this.$message.warning(this.$t("warning.noDevice"))
      }

      r.isGoingToHistory = false
      this.list = [...this.list]
    }
  }
}
</script>

<style lang="less" scoped>
ul {
  padding: 0;
}
.warningOrder {
  padding: 15px;
  width: 100%;
  height: 100%;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-size: 20px;
  }
}
div {
  position: relative;
}
span {
  position: relative;
}
.anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
span.ASC .anticon-caret-up {
  color: #1890ff;
}
span.icons {
  position: absolute;
  right: 18px;
}
span.DESC .anticon-caret-down {
  color: #1890ff;
}
.anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
/deep/ .ant-select-selection__rendered {
  font-weight: normal;
}
.IMPORTANT {
  color: orange;
}
.URGENT {
  color: red;
}
input.file {
  display: none;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.comment_icons {
  font-size: 18px;
}
.content {
  margin: 0;
  padding: 0;
  height: 32px;
  line-height: 32px;
}
.SUCCEED {
  color: green;
}
.FAILED {
  color: yellow;
}
</style>